import React, { useContext } from "react";

import { observer } from "mobx-react";

import ComponentContext from "../../../contexts/ComponentContext";
import Map from "./Map";

function HeroMap(props) {
  const { height } = useContext(ComponentContext);

  return (
    <div>
      <Map {...props} height={height} />
    </div>
  );
}

export default observer(HeroMap);
